<template>
  <div id="contractResume">
    <div class="row  mx-1">
      <div class="col-12">
        <div class="mb-3">
          <div class="generalSubtitle">Detalle economico</div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-4 col-lg-4">
            <div class="generalTitleItemModal">Pago inicial</div>
            <p>{{ prices.initialPaymentFee || '-' }} €</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-4">
            <div class="generalTitleItemModal">Cuota mensual</div>
            <p>{{ prices.monthlyFee || '-' }} €</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-4">
            <div class="generalTitleItemModal">Precio renovacion</div>
            <p>{{ prices.renewalFee || '-' }} €</p>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="mb-3">
          <div class="generalSubtitle">Terminal</div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Proveedor</div>
            <p>{{ contractData.product.supplier || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Marca</div>
            <p>{{ contractData.product.brand || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Stock</div>
            <p>{{ contractData.product.stock > 0 ? 'Sí' : 'No' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Modelo</div>
            <p>{{ contractData.product.model || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Color</div>
            <p>{{ contractData.product.color || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Capacidad</div>
            <p>{{ contractData.product.capacity || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Cuota mensual</div>
            <p>{{ contractData.product.quotaPrice + '€' || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Nº Cuotas</div>
            <p>{{ contractData.product.nQuotas || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Total</div>
            <p>{{ contractData.product.price + '€' || '-' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row  mx-1">
      <div class="col-12">
        <div class="mb-3">
          <div class="generalSubtitle">Dirección</div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Calle</div>
            <p>{{ contractData.customer.deliveryAddress.street || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Número</div>
            <p>{{ contractData.customer.deliveryAddress.number || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Piso</div>
            <p>{{ contractData.customer.deliveryAddress.floor || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Puerta</div>
            <p>{{ contractData.customer.deliveryAddress.door || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Escalera</div>
            <p>{{ contractData.customer.deliveryAddress.stair || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Código postal</div>
            <p>{{ contractData.customer.deliveryAddress.postalCode || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Localidad</div>
            <p>{{ contractData.customer.deliveryAddress.city || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Provincia</div>
            <p>{{ contractData.customer.deliveryAddress.province || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">País</div>
            <p>{{ contractData.customer.deliveryAddress.country || '-' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row mx-1">
      <div class="col-12">
        <div class="mb-3">
          <div class="generalSubtitle">Dirección de facturación</div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Calle</div>
            <p>{{ contractData.customer.billingAddress.street || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Número</div>
            <p>{{ contractData.customer.billingAddress.number || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Piso</div>
            <p>{{ contractData.customer.billingAddress.floor || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Puerta</div>
            <p>{{ contractData.customer.billingAddress.door || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Escalera</div>
            <p>{{ contractData.customer.billingAddress.stair || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Código postal</div>
            <p>{{ contractData.customer.billingAddress.postalCode || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Localidad</div>
            <p>{{ contractData.customer.billingAddress.city || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Provincia</div>
            <p>{{ contractData.customer.billingAddress.province || '-' }}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">País</div>
            <p>{{ contractData.customer.billingAddress.country || '-' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-1">
      <div class="col-12">
        <button class="btn btn-outline-secondary float-left generalSecondaryButton" @click="goBack()">Atrás</button>
        <router-link class="btn btn-outline-secondary float-left generalSecondaryButton ml-3"
          :to="{ name: 'newContractStep1' }" @click="removeStorage()">Cancelar</router-link>
        <button class="btn btn-primary float-right generalPrimaryButton" @click="submit()">Renovar</button>
      </div>
    </div>
  </div>
  <ModalFinal :id="'finalModal'" :modalTitle="'Paso final'" :class="'modal'" :showFooter="false" />
  <ModalError :id="'modalError'" :modalTitle="'SE HA PRODUCIDO UN ERROR'" :class="'modal'" :showFooter="false"
    :message="errorMessage" :code="errorCode" />
</template>
<script>
import axios from 'axios';
import ModalFinal from '../SuccessModal/FinalModal.vue';
import ModalError from '../../../Shared/ModalError.vue';
import { Modal as ModalBootstrap } from "bootstrap";
export default {
  name: 'ResumeContract',
  data() {
    return {
      contractData: this.$store.state.newContractData,
      errorMessage: '',
      errorCode: '',
      calculated: false,
      prices:{}
    };
  },
  components: {
    ModalFinal,
    ModalError,
  },
  mounted(){
    this.loadPrices()
  },
  methods: {

    submit() {
      const bodyToSend = this.$store.state.newContractData;
      bodyToSend.customer.deliveryAddress.number = bodyToSend.customer.deliveryAddress.number +
        (bodyToSend.customer.deliveryAddress.door ? ' Puerta ' + bodyToSend.customer.deliveryAddress.door : '') +
        (bodyToSend.customer.deliveryAddress.floor ? ' Planta ' + bodyToSend.customer.deliveryAddress.floor : '') +
        (bodyToSend.customer.deliveryAddress.stair ? ' Escalera ' + bodyToSend.customer.deliveryAddress.stair : '')
      bodyToSend.customer.billingAddress.number = bodyToSend.customer.billingAddress.number +
        (bodyToSend.customer.billingAddress.door ? ' Puerta ' + bodyToSend.customer.billingAddress.door : '') +
        (bodyToSend.customer.billingAddress.floor ? ' Planta ' + bodyToSend.customer.billingAddress.floor : '') +
        (bodyToSend.customer.billingAddress.stair ? ' Escalera ' + bodyToSend.customer.billingAddress.stair : '')

      let bodyToSendUpdate = {
        email: bodyToSend.customer.email || '',
        mobile: bodyToSend.customer.mobile || '',
        telephone: bodyToSend.customer.telephone || '',
        trustworthy: bodyToSend.customer.trustworthy || false,
        billingAddress: {
          street: bodyToSend.customer.billingAddress.street || '',
          number: bodyToSend.customer.billingAddress.number || '',
          postalCode: bodyToSend.customer.billingAddress.postalCode || '',
          city: bodyToSend.customer.billingAddress.city || '',
          province: bodyToSend.customer.billingAddress.province || '',
        },
        deliveryAddress: {
          street: bodyToSend.customer.deliveryAddress.street || '',
          number: bodyToSend.customer.deliveryAddress.number || '',
          postalCode: bodyToSend.customer.deliveryAddress.postalCode || '',
          city: bodyToSend.customer.deliveryAddress.city || '',
          province: bodyToSend.customer.deliveryAddress.province || '',
        }
      }

      let bodyPost={
        parentContractId: this.$store.state.contractInfo.contractId,
        deviceModel: this.$store.state.newContractData.product.brand + this.$store.state.newContractData.product.model + this.$store.state.newContractData.product.capacity + this.$store.state.newContractData.product.color,
        partCode: this.$store.state.newContractData.product.partCode,
        store: this.$cookies.get('store'),
        backOfficeUser: this.$cookies.get('username')
      }

      let urlClientes = '/customer/contact-info-by-legal-identifier/'
      axios.patch(urlClientes + bodyToSend.customer.legalIdentifier, bodyToSendUpdate)
        .then(() => {
          let urlOrder = '/contract-renewal/order';
          axios.post(urlOrder, bodyPost)
            .then(() => {
              this.removeStorage()
              var myModal = new ModalBootstrap(document.getElementById('finalModal'))
              myModal.show()
            })
            .catch((error) => {
              this.errorCode = error.response.data.code
              this.errorMessage = error.response.data.message
              var myModal = new ModalBootstrap(document.getElementById('modalError'))
              myModal.show()
            });
        });
        

    },
    goBack() {
      this.$router.push({ name: 'renewContractStep2' })
    },
    removeStorage() {
      this.$store.commit('RESET_STATE_CONTRACTS');
    },
    loadPrices(){
      axios.get('/contract-renewal/' + this.$store.state.contractInfo.contractId + '/' + this.$cookies.get('store') + '/' + this.$store.state.newContractData.product.partCode)
      .then((response) => {
        this.prices = response.data;
      })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.typeNumber::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

.typeNumber {
  appearance: textfield;
}
</style>